import Box from '@material-ui/core/Box'

import MainPhoto from './Main'
import { styles } from './styles'

const TabPanel = (props) => {
  const { children, value, index } = props
  return (
    <div>
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

const MostrarContenidoBox = ({ value, data, id, edit, img, setImg, changeRender }) => {
  const classes = styles()

  return (
    <div className={classes.style}>
      <TabPanel TabPanel value={value} index={0}>
        <MainPhoto
          edit={edit}
          dialogData={data}
          id={id}
          img={img}
          setImg={setImg}
          changeRender={changeRender}
        />
      </TabPanel>
    </div>
  )
}

export default MostrarContenidoBox
